import { ReactNode } from 'react';
import styled from 'styled-components';
import { useUIStore } from '../../hooks/stores/uiStore';

export const Main = ({ children }: { children: ReactNode }) => {
  const [UIData] = useUIStore();

  return (
    <Container $isSimulation={UIData.editorMode === 'simulation'} style={{ cursor: UIData.cursor }}>
      {children}
    </Container>
  );
};

export const Container = styled.main<{ $isSimulation?: boolean }>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  display: flex;
  transition: background var(--transition-2);

  ${({ $isSimulation }) =>
    $isSimulation &&
    `
    background: var(--neutral-5);
  `}
`;
